import { render, staticRenderFns } from "./ListPerfis.vue?vue&type=template&id=29d69b52"
import script from "./ListPerfis.vue?vue&type=script&lang=js"
export * from "./ListPerfis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports